import React from 'react'
import CalendarTodayIcon from '@material-ui/icons/CalendarToday'
import ExitToAppIcon from '@material-ui/icons/ExitToApp'
import NotificationsIcon from '@material-ui/icons/Notifications'
import PersonIcon from '@material-ui/icons/Person'
import ReplayIcon from '@material-ui/icons/Replay'
import PainterAccountMenuItem from './PainterAccountMenu/PainterAccountMenuItem'
import PainterUserAvatar from './PainterUserAvatar'
import { usePainterAccountMenuStyles } from './PainterAccountMenu/usePainterAccountMenuStyles'

interface PainterAccountMenuProps {
  userAvatarUrl?: string
  onClose: () => void
  onSchedule?: () => void
  onProfile?: () => void
  onNotifications?: () => void
  onRestart?: () => void
  onLogOut?: () => void
}

export default function PainterAccountMenu(props: PainterAccountMenuProps) {
  const { userAvatarUrl, onClose, onSchedule, onProfile, onNotifications, onRestart, onLogOut } = props
  const classes = usePainterAccountMenuStyles()

  return (
    <div className={classes.backdrop} onClick={onClose}>
      <div className={classes.surface} onClick={(e) => e.stopPropagation()}>
        <div className={classes.header}>
          <span className={classes.title}>Menu</span>
          <button type="button" className={classes.avatarBtn} onClick={onClose} aria-label="close account menu">
            <PainterUserAvatar className={classes.avatar} userAvatarUrl={userAvatarUrl} />
          </button>
        </div>
        {onSchedule && (
          <PainterAccountMenuItem
            label="Schedule"
            icon={CalendarTodayIcon}
            active
            onClick={onSchedule}
            classes={classes}
          />
        )}
        {onProfile && (
          <PainterAccountMenuItem label="Your Profile" icon={PersonIcon} onClick={onProfile} classes={classes} />
        )}
        {onNotifications && (
          <PainterAccountMenuItem
            label="Notifications"
            icon={NotificationsIcon}
            onClick={onNotifications}
            classes={classes}
          />
        )}
        <PainterAccountMenuItem label="Restart" icon={ReplayIcon} divider onClick={onRestart} classes={classes} />
        <PainterAccountMenuItem label="Log Out" icon={ExitToAppIcon} onClick={onLogOut} classes={classes} />
      </div>
    </div>
  )
}
